(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/get-json-ld/assets/javascripts/get-json-ld.js') >= 0) return;  svs.modules.push('/components/utils/get-json-ld/assets/javascripts/get-json-ld.js');
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';
var logger;
if (isServer) {
  var trinidad = require('trinidad-core').core;
  logger = trinidad.logger('utils:get-json-ld-string');
} else {
  logger = svs.core.log.getLogger('utils:get-json-ld-string');
}

function durationFormatter(milliseconds) {
  var seconds = Math.floor(milliseconds / 1000);
  var minutes = Math.floor(seconds / 60);
  return "PT".concat(minutes, "M").concat(seconds % 60, "S");
}
var validKeys = ['uploadDate', 'description', 'name', 'thumbnailUrl', 'duration'];

var getJsonLDString = function getJsonLDString(videoData) {
  if (!Object.keys(videoData) || Object.keys(videoData).length === 0) {
    logger.warn('No data was passed to getJsonLDString');
    return null;
  }
  if (!videoData.uploadDate) {
    logger.warn('uploadDate is not set, setting it to current date. This is required for a valid JSON-LD tag.');
    videoData.uploadDate = new Date().toLocaleString('sv-SE').replace(/ /g, 'T');
  }
  var keys = Object.keys(videoData);
  var invalidKeys = keys.filter(function (key) {
    return validKeys.indexOf(key) === -1;
  });
  if (invalidKeys.length > 0) {
    logger.warn("Invalid keys passed to getJsonLDString: ".concat(invalidKeys.join(', ')));
    return null;
  }
  try {
    var jsonLD = keys.reduce(function (result, key) {
      if (key in videoData && videoData[key] !== null && videoData[key] !== undefined) {
        if (key === 'duration') {
          result[key] = durationFormatter(videoData[key]);
        } else {
          result[key] = videoData[key];
        }
      }
      return result;
    }, {
      '@context': 'https://schema.org/',
      '@type': 'VideoObject'
    });
    return JSON.stringify(jsonLD);
  } catch (error) {
    logger.error('Failed to parse data in getJsonLDString', error);
    return null;
  }
};
if (isServer) {
  module.exports = getJsonLDString;
} else {
  svs.utils.getJsonLDString = getJsonLDString;
}

 })(window);